import { render, staticRenderFns } from "./posterV2.vue?vue&type=template&id=b61ab252&scoped=true&"
import script from "./posterV2.vue?vue&type=script&lang=ts&"
export * from "./posterV2.vue?vue&type=script&lang=ts&"
import style0 from "./posterV2.vue?vue&type=style&index=0&id=b61ab252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ab252",
  null
  
)

export default component.exports